import { EnrollmentStatus, OnboardingPeriodReportDto } from '@zorro/clients';
import { APP_ROUTES } from '@zorro/common-utils';
import { ReactNode } from 'react';
import { $enum } from 'ts-enum-util';

export enum EmployeePageTabType {
  PLANS = 'PLANS',
  ACTIVITY_LOG = 'ACTIVITY_LOG',
  FILES = 'FILES',
  MEMBERS = 'MEMBERS',
  ZORRO_PAY = 'ZORRO_PAY',
}

const noBenefitsSubmittedStatuses = [
  EnrollmentStatus.PENDING_ELECTION_WINDOW,
  EnrollmentStatus.ELECTION_ACTIVE,
  EnrollmentStatus.ELECTION_ACTIVE_STARTED,
  EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED,
  EnrollmentStatus.WAIVED_ELECTION,
  EnrollmentStatus.WAIVED_COVERAGE,
  EnrollmentStatus.DEADLINE_PASSED,
  EnrollmentStatus.NO_ENROLLMENTS,
];

export const getEmployeePageTabConfig = (
  route: EmployeePageTabType,
  isDon: boolean,
  onboardingPeriod: OnboardingPeriodReportDto | undefined,
  zorroPayRightSection?: ReactNode
) => {
  const hasNoSubmittedBenefits = onboardingPeriod?.enrollmentStatus
    ? noBenefitsSubmittedStatuses.includes(onboardingPeriod.enrollmentStatus)
    : false;
  return $enum.mapValue(route).with<{
    label: string;
    route: keyof typeof APP_ROUTES;
    index: number;
    isDisabled?: boolean;
    rightSection?: ReactNode;
  }>({
    [EmployeePageTabType.PLANS]: {
      label: 'Plan',
      route: isDon ? 'DON_EMPLOYEE_PLANS_TAB' : 'OPS_EMPLOYEE_PLANS_TAB',
      index: 0,
    },
    [EmployeePageTabType.ACTIVITY_LOG]: {
      label: 'Activity log',
      route: isDon
        ? 'DON_EMPLOYEE_ACTIVITY_LOG_TAB'
        : 'OPS_EMPLOYEE_ACTIVITY_LOG_TAB',
      index: 1,
    },
    [EmployeePageTabType.FILES]: {
      label: 'Files',
      route: isDon ? 'DON_EMPLOYEE_FILES_TAB_V2' : 'OPS_EMPLOYEE_FILES_TAB_V2',
      index: 2,
    },
    [EmployeePageTabType.MEMBERS]: {
      label: 'Members',
      route: isDon ? 'DON_EMPLOYEE_MEMBERS_TAB' : 'OPS_EMPLOYEE_MEMBERS_TAB',
      index: hasNoSubmittedBenefits ? 4 : 3,
      isDisabled: hasNoSubmittedBenefits,
    },
    [EmployeePageTabType.ZORRO_PAY]: {
      label: 'Zorro Pay',
      route: isDon
        ? 'DON_EMPLOYEE_ZORRO_PAY_TAB'
        : 'OPS_EMPLOYEE_ZORRO_PAY_TAB',
      index: hasNoSubmittedBenefits ? 3 : 4,
      isDisabled: hasNoSubmittedBenefits,
      rightSection: zorroPayRightSection,
    },
  });
};

export const getEmployeePageTabs = (
  isDon: boolean,
  onboardingPeriod: OnboardingPeriodReportDto | undefined
) => {
  return Object.values(EmployeePageTabType).sort((first, second) => {
    const firstConfig = getEmployeePageTabConfig(
      first,
      isDon,
      onboardingPeriod
    );
    const secondConfig = getEmployeePageTabConfig(
      second,
      isDon,
      onboardingPeriod
    );

    return firstConfig.index - secondConfig.index;
  });
};
